module.exports = __webpack_public_path__ + "img/icon_number_0@3x.6615c9da.png";